import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@material-ui/core/styles';

import Main from '../components/main';
import Socket from '../components/socket';
import { AppProvider } from '../providers/app';
import theme from '../theme';

const app = document.getElementById('main');
const root = createRoot(app);
root.render(
  <AppProvider>
    <ThemeProvider theme={theme}>
      <div>
        <Socket />
        <Main />
      </div>
    </ThemeProvider>
  </AppProvider>
);

// Remove the static boot loader (views/index.ejs) once the app has painted. It's
// a sibling of #main, not a child, so React never owns it — we drop it after two
// animation frames so there's no white flash between the spinner and first paint.
const bootLoader = document.getElementById('app-boot-loader');
if (bootLoader) {
  requestAnimationFrame(() => requestAnimationFrame(() => bootLoader.remove()));
}
